import { useAppDispatch, useAppSelector } from "app/hooks"
import {
  checkIsUserHasLogThreeMeal,
  turnOffShowFitBanner,
} from "./notificationSlice"
import { useEffect } from "react"
import { useFailed } from "./hooks"
import { isInWebView } from "utils/webViewDetection"



const useShowFitBanner = () => {
  const checkIsUserHasLogThreeMealFailed = useAppSelector(
    (state) => state.notification.checkIsUserHasLogThreeMealFailed,
  )

  const shouldShowFitBanner = useAppSelector(
    (state) => state.notification.shouldShowFitBanner,
  )

  const isTurnedOffShowFitBanner = useAppSelector(
    (state) => state.notification.isTurnedOffShowFitBanner,
  )
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!isInWebView() && !isTurnedOffShowFitBanner) {
      dispatch(checkIsUserHasLogThreeMeal())
    }
  }, [isTurnedOffShowFitBanner])

  useFailed(checkIsUserHasLogThreeMealFailed)

  return {
    shouldShowFitBanner,
  }
}

export const useTurnOffFitBanner = () => {
  const dispatch = useAppDispatch()
  const onTurnOffShowFitBanner = () => {
    dispatch(turnOffShowFitBanner())
  }

  return onTurnOffShowFitBanner
}

export default useShowFitBanner
